import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "m-16"
};
const _hoisted_2 = {
  class: "wrap bg_white"
};
const _hoisted_3 = {
  class: "p-16"
};
const _hoisted_4 = {
  key: 0,
  class: "isGreen"
};
const _hoisted_5 = {
  key: 1,
  class: "isYellow"
};
const _hoisted_6 = {
  key: 2,
  class: "isRed"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("main", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
    class: "top-box"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        class: "m-r-16",
        size: "small",
        onClick: $options.addAgv
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createElementVNode("i", {
          class: "el-icon-circle-plus",
          style: {
            "margin-right": "5px",
            "font-size": "14px"
          }
        }, null, -1), _createTextVNode("新增")])),
        _: 1,
        __: [12]
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: $options.exportHandle
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("i", {
          class: "Files"
        }, null, -1), _createTextVNode("导出")])),
        _: 1,
        __: [13]
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form, {
        ref: "form",
        model: $data.filter,
        "label-width": "80px",
        "label-position": "left",
        class: "m-t-20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "AGV类型",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: $data.filter.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.filter.type = $event),
                placeholder: "请选择AGV类型",
                onChange: $options.changeType
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: "-1"
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("全部")])),
                  _: 1,
                  __: [14]
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.types, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue", "onChange"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "AGV状态",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: $data.filter.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.filter.status = $event),
                placeholder: "请选择AGV状态",
                onChange: $options.changeAGVStatus
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: "-1"
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("全部")])),
                  _: 1,
                  __: [15]
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.statusData, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue", "onChange"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "AGV编码",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.filter.agv_code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.filter.agv_code = $event),
                onKeyup: _withKeys($options.changeCode, ["enter"]),
                clearable: "",
                onClear: _cache[3] || (_cache[3] = $event => $options.clearInput('agv_code')),
                placeholder: "请输入AGV编码"
              }, null, 8, ["modelValue", "onKeyup"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "AGV名称",
              prop: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.filter.agv_title,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.filter.agv_title = $event),
                onKeyup: _withKeys($options.changeName, ["enter"]),
                clearable: "",
                onClear: _cache[5] || (_cache[5] = $event => $options.clearInput('agv_title')),
                placeholder: "请输入AGV名称"
              }, null, 8, ["modelValue", "onKeyup"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox, {
              modelValue: $data.is_status,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.is_status = $event),
              onChange: $options.changeCheckbox,
              label: "仅显示启用的AGV"
            }, null, 8, ["modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              class: "m-r-16",
              plain: "",
              onClick: _cache[7] || (_cache[7] = $event => $options.resetData())
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("重置")])),
              _: 1,
              __: [16]
            }), _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $options.searchClick
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("搜索")])),
              _: 1,
              __: [17]
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table, {
        data: $data.tableData,
        style: {
          "width": "auto"
        },
        border: "",
        "header-cell-style": $data.header_style
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "agv_title",
          label: "AGV名称",
          width: "200",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "agv_code",
          label: "AGV编码",
          width: "120",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "type_name",
          label: "AGV类型",
          width: "310",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "AGV状态",
          width: "80",
          align: "center"
        }, {
          default: _withCtx(scope => [scope.row.status == '0' ? (_openBlock(), _createElementBlock("span", _hoisted_4, "空闲")) : scope.row.status == '1' ? (_openBlock(), _createElementBlock("span", _hoisted_5, "任务中")) : (_openBlock(), _createElementBlock("span", _hoisted_6, "充电中"))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "address_title",
          label: "当前所在位置",
          width: "200",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "cart_name",
          label: "当前承载料车",
          width: "240",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "task_code",
          label: "当前任务",
          width: "240",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "is_status",
          label: "是否启用",
          width: "80",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_switch, {
            modelValue: scope.row.is_status,
            "onUpdate:modelValue": $event => scope.row.is_status = $event,
            onChange: $event => $options.changeStatus($event, scope.row.id),
            "active-value": 0,
            "inactive-value": 1,
            "active-color": "#13ce66",
            "inactive-color": "#EDEFF4"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "",
          label: "操作",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            class: "isBlue Cursor m-r-16",
            onClick: $event => $options.editClick(scope.row.id)
          }, "编辑", 8, _hoisted_7), _createElementVNode("span", {
            class: "Cursor",
            onClick: $event => $options.deleteClick(scope.row)
          }, "删除", 8, _hoisted_8)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"]), _createVNode(_component_el_pagination, {
        class: "pagination m-t-16",
        "current-page": $data.filter.page,
        "page-sizes": [10, 20, 30, 40],
        "page-size": $data.filter.size,
        layout: "total, sizes, prev, pager, next, jumper",
        total: $data.total,
        onSizeChange: $options.changePageSize,
        onCurrentChange: $options.changePage
      }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])]),
      _: 1
    })]),
    _: 1
  })])]), _createVNode(_component_el_dialog, {
    class: "addDialog",
    modelValue: $data.dialogAdd,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.dialogAdd = $event),
    title: $data.dialogTitle,
    width: "348px",
    "before-close": $options.handleClose
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_button, {
      class: "m-r-16",
      size: "small",
      onClick: $options.handleClose
    }, {
      default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("取消")])),
      _: 1,
      __: [18]
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: $options.comfirm
    }, {
      default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("确认")])),
      _: 1,
      __: [19]
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.addForm,
      "label-width": "80px",
      "label-position": "left"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "AGV编码"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.addForm.agv_code,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.addForm.agv_code = $event),
          placeholder: "新增后自动生成",
          disabled: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "AGV名称"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.addForm.agv_title,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.addForm.agv_title = $event),
          placeholder: "请输入AGV名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "AGV类型"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.addForm.type,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.addForm.type = $event),
          placeholder: "请选择AGV状态"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.types, (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue", "title", "before-close"])]);
}